import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createBlock as _createBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ebda6b70"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "menu" }
const _hoisted_2 = { class: "footer" }
const _hoisted_3 = { class: "text-center text-body-2" }
const _hoisted_4 = {
  href: "https://github.com/alexandertopskiy/phone-book",
  target: "_blank"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list_group = _resolveComponent("v-list-group")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_LangSwitch = _resolveComponent("LangSwitch")!
  const _component_v_icon = _resolveComponent("v-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_list, {
      density: "compact",
      nav: ""
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.menuItems, (item) => {
          return (_openBlock(), _createElementBlock(_Fragment, {
            key: item.value
          }, [
            (!item.subItems)
              ? (_openBlock(), _createBlock(_component_v_list_item, {
                  key: 0,
                  title: item.title,
                  "prepend-icon": item.icon,
                  class: _normalizeClass(item.class),
                  onClick: ($event: any) => ($options.onClickMenu(item.action))
                }, null, 8, ["title", "prepend-icon", "class", "onClick"]))
              : (_openBlock(), _createBlock(_component_v_list_group, {
                  key: 1,
                  value: item.value
                }, {
                  activator: _withCtx(({ props }) => [
                    _createVNode(_component_v_list_item, _mergeProps(props, {
                      "prepend-icon": item.icon,
                      title: item.title
                    }), null, 16, ["prepend-icon", "title"])
                  ]),
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.subItems, (subitem) => {
                      return (_openBlock(), _createBlock(_component_v_list_item, {
                        key: subitem.value,
                        title: subitem.title,
                        "prepend-icon": subitem.icon,
                        onClick: ($event: any) => ($options.onClickMenu(subitem.action))
                      }, null, 8, ["title", "prepend-icon", "onClick"]))
                    }), 128))
                  ]),
                  _: 2
                }, 1032, ["value"]))
          ], 64))
        }), 128))
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_LangSwitch),
      _createElementVNode("p", _hoisted_3, [
        _createTextVNode(" view "),
        _createElementVNode("a", _hoisted_4, [
          _createTextVNode("GitHub project "),
          _createVNode(_component_v_icon, null, {
            default: _withCtx(() => [
              _createTextVNode("mdi-github")
            ]),
            _: 1
          })
        ])
      ])
    ])
  ]))
}